import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterSliders = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 11.625H5.25M8.25 11.625H15M12.75 6.375H15M3 6.375H9.75",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 6.375C9.75 7.20343 10.4216 7.875 11.25 7.875C12.0784 7.875 12.75 7.20343 12.75 6.375C12.75 5.54657 12.0784 4.875 11.25 4.875C10.4216 4.875 9.75 5.54657 9.75 6.375Z",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.25 11.625C5.25 12.4534 5.92157 13.125 6.75 13.125C7.57843 13.125 8.25 12.4534 8.25 11.625C8.25 10.7966 7.57843 10.125 6.75 10.125C5.92157 10.125 5.25 10.7966 5.25 11.625Z",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgFilterSliders;
